/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Title_1Inputs */

const en_blog_title_1 = /** @type {(inputs: Blog_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A closer look`)
};

const lv_blog_title_1 = /** @type {(inputs: Blog_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuvāk iepazīt`)
};

/**
* | output |
* | --- |
* | "A closer look" |
*
* @param {Blog_Title_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const blog_title_1 = /** @type {((inputs?: Blog_Title_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Title_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_blog_title_1(inputs)
	return en_blog_title_1(inputs)
});